import { TimeZoneSelect } from '@/features/experiences/components/Controls/controls/EventsControl/TimeZoneSelect';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { useUpdateExperience } from '@/features/experiences/hooks/useUpdateExperience';
import { useAnalytics } from '@/hooks/useAnalytics';
import { TimeZoneDisplay } from '@/types/gql.generated';
import { Box } from '@/ui';
import { RadioRow, SidebarCard } from '../SidebarKit';
import { SectionHeader } from './SectionHeader';

export const TimeZoneSection = () => {
  const { trackEvent } = useAnalytics();
  const { experience } = usePageExperienceContext();
  const { setTimezone, setTimezoneDisplay } = useUpdateExperience();

  return (
    <Box maxW="560px">
      <SectionHeader
        description="Time zone of this schedule"
        title="Time zone"
      />

      <Box
        bg="surface.card"
        borderColor="line.card"
        borderRadius="ah-xl"
        borderWidth="1px"
        boxShadow="0 1px 2px rgba(60,50,110,0.05)"
        mb={3}
        p={3}
      >
        <TimeZoneSelect
          size="sm"
          value={experience.timeZone}
          onChange={(e) => {
            trackEvent('experience:author change event-settings', {
              setting: 'timezone',
            });
            setTimezone(e.currentTarget.value);
          }}
        />
      </Box>

      <SidebarCard>
        <RadioRow
          isActive={experience.timeZoneDisplay === TimeZoneDisplay.Experience}
          label="Show times in this time zone"
          variant="check"
          onClick={() => {
            trackEvent('experience:author change event-settings', {
              setting: 'timezone-display',
            });
            setTimezoneDisplay(TimeZoneDisplay.Experience);
          }}
        />
        <RadioRow
          isActive={experience.timeZoneDisplay === TimeZoneDisplay.Visitor}
          label="Show in each visitor's time zone"
          variant="check"
          onClick={() => {
            trackEvent('experience:author change event-settings', {
              setting: 'timezone-display',
            });
            setTimezoneDisplay(TimeZoneDisplay.Visitor);
          }}
        />
      </SidebarCard>
    </Box>
  );
};
